// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__HmZWm","additionalInfo":"AgreementModal_additionalInfo__1WRu8"};